export default "__VITE_ASSET__BoOPLrn5__"